import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NearbyCard from './NearbyCard';
import InteractiveMap from '../../../../SolvPatternLibrary/InteractiveMap/index';
import DefaultPin from '../../../../SolvPatternLibrary/InteractiveMap/DefaultPin';
import CurrentPin from '../../../../SolvPatternLibrary/InteractiveMap/CurrentPin';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { NEARBY_ANCHOR_ID } from '../../Mobile/Mobile';
import { URGENT_CARE_NEAR_ME_PATH } from '../../../../../constants';
import { BASE_URL } from '../../../../../config';
import { isEmptyArray } from '../../../../../core/util/array';
import TrackImpression from '../../../../../core/tracking/impression/TrackNearbyLocationsImpression';
import { PRODUCT_TYPE } from '../../../../../core/tracking/impression/constants';

const Root = styled.div`
  -webkit-font-smoothing: antialiased;
  border-radius: 4px;
  border: ${colors.borderLine} 1px solid;
`;

const NearbyAnchor = styled.div`
  transform: translateY(-120px);
`;

const Banner = styled.div`
  font-family: ${fontFamily.medium};
  font-size: ${fontSize.medium};
  padding: 20px 10px;
  background-color: ${colors.whiteGrey};
  color: ${colors.squid};
  text-align: center;
  letter-spacing: -0.23px;
`;

const Map = styled(InteractiveMap)`
  height: 200px;
  width: 100%;
`;

const CardLi = styled(NearbyCard)`
  border-top: ${colors.borderLine} 1px solid;

  &:last-child {
    border-bottom: ${colors.borderLine} 1px solid;
  }
`;

const LocationsContainer = styled.ul`
  margin: 0;
  padding: 0;
`;

const FindMore = styled.a`
  display: block;
  color: ${colors.link};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.medium};
  padding: 20px;
  background-color: ${colors.greyDim};
  cursor: pointer;
  margin-left: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const FindMoreContainer = styled.div`
  display: flex;
  color: ${colors.link};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.medium};
  padding: 20px;
  background-color: ${colors.greyDim};
  justify-content: center;
`;

export default class NearbyClinics extends PureComponent {
  static propTypes = {
    currentLocation: PropTypes.object.isRequired,
    nearbyClinics: PropTypes.array.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = { nearbyClinics: [] };

  genMapMarkers = () => {
    const { nearbyClinics, currentLocation } = this.props;
    const markers = nearbyClinics
      .filter(({ latLong }) => latLong && latLong.latitude && latLong.longitude)
      .map(({ latLong }) => ({
        lat: latLong.latitude,
        lng: latLong.longitude,
        Marker: DefaultPin,
      }));
    if (currentLocation) {
      markers.push({
        lat: currentLocation.latLong.latitude,
        lng: currentLocation.latLong.longitude,
        Marker: CurrentPin,
      });
    }

    return markers;
  };

  render = () => {
    const { nearbyClinics, className } = this.props;
    return (
      <Root className={className}>
        <NearbyAnchor id={NEARBY_ANCHOR_ID} />
        <Banner>NEARBY CLINICS</Banner>
        <Map markers={this.genMapMarkers()} />
        <LocationsContainer>
          {!isEmptyArray(nearbyClinics) && (
            <Fragment>
              <TrackImpression source={PRODUCT_TYPE.NEARBY_MODULE} locationList={nearbyClinics} />
              {nearbyClinics.map((location, i) => (
                <CardLi key={i} location={location} />
              ))}
            </Fragment>
          )}
        </LocationsContainer>
        <FindMoreContainer>
          <FindMore href={`${BASE_URL}${URGENT_CARE_NEAR_ME_PATH}`}>
            Find Urgent Care Near Me
          </FindMore>
        </FindMoreContainer>
      </Root>
    );
  };
}
